import * as React from 'react';
export const MultilineTranslation = props => {
    const translated = props.t(props.translationKey, Object.assign(Object.assign({}, props.options), { returnObjects: true }));
    if (typeof translated === 'string') {
        return React.createElement("p", null, translated);
    }
    return (React.createElement(React.Fragment, null, translated.map((line, index) => React.createElement("p", { key: index.toString() }, line))));
};
//# sourceMappingURL=MultilineTranslation.js.map